<template>
    <div>

        <app-bar
                :backTo="back_to"
                hideMenu
        ></app-bar>

        <div v-if="club && public_status">

            <v-container v-if="club.social" class="pa-0 ma-0 text-center socialbar">
                <v-row no-gutters>
                    <template>
                        <v-col v-for="(i,s) in club.social" :key="i">
                            <v-btn :href="s.link" class="py-6" large elevation="0" block tile color="deep-purple darken-1"
                                   v-if="s.type !== 'site'">
                                <font-awesome-icon size="lg" inverse :icon="['fab', s.type]"/>
                            </v-btn>
                            <v-btn :href="s.link" class="py-6" large elevation="0" block tile color="deep-purple darken-1"
                                   v-else>
                                <font-awesome-icon inverse size="lg" :icon="['fas', 'link']"/>
                            </v-btn>
                        </v-col>
                    </template>
                </v-row>
            </v-container>

            <v-card tile>

                <v-img :height="220" :src="club.cover">

                    <template v-slot:placeholder>
                        <v-progress-linear color="black" height="2" indeterminate></v-progress-linear>
                    </template>

                    <v-app-bar flat color="rgba(0, 0, 0, .2)">
                        <v-toolbar-title class="title white--text pl-0 text-e">
                            <v-icon color="white">mdi-map-marker</v-icon>
                            <strong>{{club.province}}</strong>
                        </v-toolbar-title>

                        <v-spacer></v-spacer>
                    </v-app-bar>

                </v-img>

                <div class="pb-0 mb-0 text-center negative-margin-top">
                    <v-avatar color="#f7f7f7" size="130" class="elevation-8 border">
                        <v-img class="pa-2" :alt="club.name"
                               :src="club.logo">
                            <template v-slot:placeholder>
                                <v-progress-circular class="mt-12" width="2" indeterminate></v-progress-circular>
                            </template>
                        </v-img>
                    </v-avatar>
                    <h3 class="py-2">{{club.name}}</h3>
                </div>


                <v-container class="pb-0 mb-0 text-center">
                    <v-row>
                        <v-col>
                            <v-icon size="20">mdi-account-group</v-icon>
                            <span class="d-block font-weight-light">Membri<br><strong>{{club.members.length}}</strong></span>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col>
                            <v-icon size="20">mdi-map-search</v-icon>
                            <span class="d-block font-weight-light">Eventi<br><strong>{{club.events.length}}</strong></span>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col>
                            <v-icon size="20">mdi-target-variant</v-icon>
                            <span class="d-block font-weight-light">Campi da Gioco<br><strong>{{club.fields.length}}</strong></span>
                        </v-col>
                    </v-row>
                </v-container>


            </v-card>

            <v-expansion-panels dark tile accordion>

                <v-expansion-panel v-if="club.description">
                    <v-expansion-panel-header>
                        <span class="text-uppercase">Su di noi...</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        {{club.description}}
                    </v-expansion-panel-content>
                </v-expansion-panel>

            </v-expansion-panels>

            <v-list v-for="(item,i) in club.info" :key="i">
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon color="deep-purple darken-1">{{item.icon}}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <h3>{{item.title}}</h3>
                        <p class="text-body-2">{{item.value}}</p>
                    </v-list-item-content>

                    <v-list-item-icon v-if="item.title === 'Email' || item.title === 'Telefono'">
                        <v-btn fab small outlined color="deep-purple darken-1" :href="action(item.value)">
                            <v-icon>mdi-arrow-right</v-icon>
                        </v-btn>
                    </v-list-item-icon>
                </v-list-item>
                <v-divider v-if="i !== Object.keys(club.info).pop()" inset></v-divider>
            </v-list>


            <div class="text-center text--accent-4 title pt-5 text-uppercase">I NOSTRI MEMBRI</div>

            <v-container class="pb-0 mb-0 text-center">
                <v-row>

                    <v-col cols="4" v-for="member in club.members" :key="club.members.container_id">
                        <v-card tile dark @click="userProfile(member.user_id)">
                            <v-img :height="120" :src="member.avatar">
                                <template v-slot:placeholder>
                                    <v-progress-linear color="black" height="2" indeterminate></v-progress-linear>
                                </template>
                            </v-img>
                            <div class="pa-3">
                                {{member.nickname}}
                            </div>
                        </v-card>
                    </v-col>

                </v-row>
            </v-container>

            <v-container class="pb-0 mb-0 text-center">
                <v-row>
                    <v-col>
                        <v-btn :href="club.url" x-large block>Scopri di più sulla loro pagina!</v-btn>
                    </v-col>
                </v-row>
            </v-container>

        </div>

        <div v-if="!public_status">

            <v-container>
                <v-row align="center" no-gutters>
                    <v-col class="text-center pt-15">
                        <v-icon class="d-block rem4" color="white">mdi-alert-decagram-outline</v-icon>
                        <span class="title">Il club non ha ancora<br>pubblicato la pagina!</span>
                    </v-col>
                </v-row>
            </v-container>

        </div>


    </div>
</template>

<script>
    import axios from 'axios'
    import {mapState, mapMutations, mapGetters} from 'vuex'

    export default {
        name: "club",
        props: {
            club_id: Number,
            back_to: Object
        },
        data: () => ({
            allLoaded: false,
            club: false,
            public_status: true
        }),
        computed: {
            ...mapState([
                'loggedIn',
                '_token'
            ]),
            ...mapGetters([
                'getMemberID',
                'getClubID',
                'getMainClubID',
                'isAdmin',
            ]),
        },
        mounted() {
            if (!this.club_id) {
                this.$router.push({name: 'home'})
            }
            setTimeout(() => {
                this.getClubData()
            }, 300);
        },
        methods: {
            getClubData() {
                this.setLoading(true);
                this.allLoaded = false;
                axios
                    .post(this.$store.state.ROOT_API + '/club/get', {club_id: this.club_id}, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.getters.getToken
                        }
                    })
                    .then((res) => {
                        console.log(res.data);
                        this.setLoading(false);
                        if (res.data.status !== false) {
                            this.club = res.data;
                            this.allLoaded = true;
                        } else {
                            this.public_status = false;
                        }
                    })
                    .catch((error) => {
                        console.error(error)
                    })
            },
            ...mapMutations([
                'setLoading',
                'setFlash'
            ]),
            action(value) {
                return (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value) ? 'mailto:' : 'callto:') + value;
            },
            userProfile(user_id) {
                let params = {user_id: user_id, back_to: this.$route};
                this.$router.push({name: 'member', params: params})
            }
        }
    }
</script>

<style scoped>
    .negative-margin-top {
        margin-top: -80px !important
    }

    .socialbar {
        position: -webkit-sticky;
        position: sticky;
        top: 56px;
        z-index: 2;
    }
</style>